import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteTemplate } from 'API/Templates/deleteTemplate';

const useDeleteTemplate = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const deleteTemplateById = async (templateId) => {
        try {
            const response = await deleteTemplate(templateId);
            return response.data;
        } catch (error) {
            console.error('Error deleting template:', error);
            throw error;
        }
    };

    return useMutation({
        mutationFn: deleteTemplateById,
        onSuccess: (data, templateId) => {
            queryClient.invalidateQueries({ queryKey: ['Templates'] });
            queryClient.removeQueries({ queryKey: ['Template', templateId] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useDeleteTemplate;
